import React, { Component } from 'react'
import Video from './Video'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

class App extends Component {
	render() {
		return (
			<div>
				<Router>
					<Switch>
						<Route path="/room/:roomId" exact component={Video} />
						<Redirect to="/room/invalid" />
					</Switch>
				</Router>
			</div>
		)
	}
}

export default App;
